<div class="header">
  <div class="flex w-full justify-content-between py-3 smm-container align-items-center">
    <div class="logo">
      <img
        [ngSrc]="currentTheme() === 'dark' ? '/imgs/logo-dark.svg' : '/imgs/logo.svg'"
        alt="Echoza Logo"
        width="140"
        height="50"
        class="logo"
      />
    </div>
    <div class="burger-menu d-xl-none" [class.open]="isMenuOpen()" (click)="toggleMenu()">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>

    <nav class="nav-links flex d-none d-xl-flex">
      @for (nav of navs; track $index) {
        <a
          (click)="handleNavClick(nav.fragment)"
          [class.active]="activeSection() === nav.fragment"
          class="nav-link caption__accent cursor-pointer"
          >{{ nav.label | translate }}</a
        >
      }
    </nav>
    <div class="cta flex gap-4 align-items-center d-none d-xl-flex">
      <img
        [ngSrc]="
          currentTheme() === 'dark' ? '/imgs/icons/light-mode.png' : '/imgs/icons/dark-mode.png'
        "
        width="20"
        height="20"
        alt="change theme icon"
        class="dark-mode-icon cursor-pointer"
        (click)="toggleTheme()"
      />
      <p class="highlight__accent cursor-pointer" (click)="toggleLang()">
        {{ 'BUTTONS.LANG' | translate }}
      </p>

      <a
        class="login-btn highlight__accent"
        href="https://app.echoza.ai/login"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'BUTTONS.LOGIN' | translate }}</a
      >
      <a
        href="https://app.echoza.ai/signup"
        target="_blank"
        class="primary-btn highlight__accent"
        rel="noopener noreferrer"
        >{{ 'BUTTONS.BOOK_A_DEMO' | translate }}</a
      >
    </div>
  </div>
</div>
